import { Component } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { UserService } from '../services/user.service';
import { IntercomService } from '../services/intercom.service';

declare let window: any;

@Component({
  standalone: false,
  selector: 'app-help',
  templateUrl: './help.page.html',
  styleUrls: ['./help.page.scss'],
})
export class HelpPage {
  constructor(
    private userService: UserService,
    private platform: Platform,
    private modalController: ModalController,
    private intercomService: IntercomService
  ) {
  }

  public ionViewWillEnter() {
  }

  public onDismiss() {
    this.modalController.dismiss();
  }

  public redirectToHelpCenterLink() {
    const url = `https://support.salonmonster.com`;
    if (this.platform.is('capacitor')) {
      // Opens in system browser on mobile
    } else {
      const win = window.open(url, '_blank');
      win.focus();
    }
  }

  public showChat() {
    this.intercomService.show();
  }
}
